<template>
  <div class="RFIDsolve-container">
    <div class="RFIDsolve-container-banner">
      <img
        src="https://image.bookgo.com.cn/bgOfficial/banners/RFID-banner.png"
        alt=""
      />
      <div class="banner-wordbox">
        <div class="banner-wordbox-content">
          <h2 class="banner-title">RFID图书馆解决方案</h2>
          <p class="banner-desc" style="width:33.4rem">
            RFID图书馆是将RFID射频技术、可编程控制技术以及网络通信技术相结合建立的一种新型的智能化、自动化管理模式的图书馆。博库RFID图书馆解决方案覆盖图书注册、图书上架、自助借还以及图书安全检测等全部流程。
          </p>
        </div>
      </div>
    </div>
    <!-- RFID方案整体流程 -->
    <div class="RFIDsolve-container-process">
      <h2 class="RFIDsolve-container-process-title title-common">
        RFID方案整体流程
      </h2>
      <div class="RFIDsolve-container-process-content">
        <img
          src="https://image.bookgo.com.cn/bgOfficial/rfid/rfid-process.png"
          alt=""
        />
        <div class="RFIDsolve-container-process-content-left">
          <img
            src="https://image.bookgo.com.cn/bgOfficial/rfid/rfid-left-round.png"
            alt=""
          />
        </div>
        <div class="RFIDsolve-container-process-content-right">
          <img
            src="https://image.bookgo.com.cn/bgOfficial/rfid/rfid-right-round.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 功能优势 -->
    <div class="RFIDsolve-container-strength">
      <h2 class="RFIDsolve-container-strength-title title-common">
        功能优势
      </h2>
      <ul class="RFIDsolve-container-strength-content">
        <li>
          <div class="RFIDsolve-container-strength-content-imgbox">
            <img
              src="https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-round1.png"
              alt=""
            />
          </div>

          <h3>自助服务</h3>
          <p>依托智能化设备和软件平台， 为读者提供无人干预的全自助借阅服务</p>
        </li>
        <li>
          <div class="RFIDsolve-container-strength-content-imgbox">
            <img
              src="https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-round2.png"
              alt=""
            />
          </div>

          <h3>高效盘点</h3>
          <p>智能盘点推车和手持盘点终端灵活搭配，助力馆员高效盘点图书。</p>
        </li>
        <li>
          <div class="RFIDsolve-container-strength-content-imgbox">
            <img
              src="https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-round3.png"
              alt=""
            />
          </div>

          <h3>安全可靠</h3>
          <p>支持“离线模式”和“在线模式”两种防盗模式，自由选配，保障图书安全</p>
        </li>
      </ul>
    </div>
    <!-- 设计理念 -->
    <div class="RFIDsolve-container-philosophy">
      <h2 class="RFIDsolve-container-philosophy-title title-common">
        设计理念
      </h2>
      <ul class="RFIDsolve-container-philosophy-content">
        <li>
          <div class="RFIDsolve-container-philosophy-content-imgbox">
            <img
              src="https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-round4.png"
              alt=""
            />
          </div>

          <h3>一体化设计</h3>
          <p>借还、办证一体化；馆员工作站一体化 智能书架一体化</p>
        </li>
        <li>
          <div class="RFIDsolve-container-philosophy-content-imgbox">
            <img
              src="https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-round5.png"
              alt=""
            />
          </div>

          <h3>多操作方式设计</h3>
          <p>刷脸、刷证、刷卡、刷码、手机号身份验证</p>
        </li>
        <li>
          <div class="RFIDsolve-container-philosophy-content-imgbox">
            <img
              src="https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-round6.png"
              alt=""
            />
          </div>

          <h3>人性化体验设计</h3>
          <p>语音交互、人体感应、精美界面、简洁易懂</p>
        </li>
      </ul>
    </div>
    <!-- 整体产品方案 -->
    <div class="RFIDsolve-container-product">
      <h2 class="RFIDsolve-container-product-title title-common">
        整体产品方案
      </h2>
      <h3>RFID图书馆产品方案</h3>
      <div class="RFIDsolve-container-product-content">
        <ul class="RFIDsolve-container-product-content-list">
          <li v-for="(item, i) in productList" :key="i">
            <img :src="item.pic" alt="" />
            <p>{{ item.name }}</p>
            <div
              class="RFIDsolve-container-product-content-list-desc"
              v-if="item.introduction !== ''"
            >
              <h4>简介 -</h4>
              <p
                class="RFIDsolve-container-product-content-list-desc-introduction"
              >
                {{ item.introduction }}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <toTop />
  </div>
</template>

<script>
import toTop from "@/assets/components/toTop";
export default {
  components: { toTop },
  data() {
    return {
      productList: [
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-product1.png",
          name: "RFID标签和读者证",
          introduction:
            "智能RFID标签在图书馆行业的应用，大大改变了整个书籍流通的效率，迈向互联时代。RFID分高频和超高频，在书籍中、读者证中、层架标签中都采用了RFID芯片和通信机制。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-product2.png",
          name: "RFID馆员工作站",
          introduction:
            "一体化馆员工作站是将RFID读写板、图书标签转换系统和显示屏结合的智能一体机。可对图书标签和读者证卡进行编写、识别和流通状态处理，用于图书的标签转换及图书人工借还状态处理。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-product3.png",
          name: "立式RFID借还办证一体机",
          introduction:
            "自助借还一体机采用立体式设计，提供便捷化的操作模式和友好的图形界面，集借还书、检索、缴费、电子书借阅等多功能于一体，同时满足图书流通的多种业务需求，为读者提供智能化的自助服务。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-product4.png",
          name: "桌面式RFID借还办证一体机",
          introduction:
            "自助借还一体机采用立体式设计，提供便捷化的操作模式和友好的图形界面，集借还书、检索、缴费、电子书借阅等多功能于一体，同时满足图书流通的多种业务需求，为读者提供智能化的自助服务。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-product5.png",
          name: "智能书架",
          introduction:
            "智能书架产品以RFID技术为核心，结合工控机、网络控制、灯光控制、冲压结构等形成的可以对图书进行自动盘点和查询的高性能智能图书存放产品。该产品可以大大降低图书盘点时间，有效节约了借阅者的查书时间，真正做到了对图书管理的智能化和高效化。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-product6.png",
          name: "RFID24小时还书机",
          introduction:
            "24小时自助还书机是一款人性化、智能化的还书设备，读者还书将不再受图书馆开、闭管时间的限制，可在任意时间还书。设备可配合自动分拣设备和码放设备使读者还回的图书自动分进不同的还书车，大大降低图书馆工作人员的工作量，提升效率。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-product7.png",
          name: "RFID手持盘点仪",
          introduction:
            "智能盘点设备能够方便图书工作人员进行图书上架、图书盘点、统计查询等工作。移动盘点车可搭配多个手持盘点终端，满足多人同时协同盘点。盘点系统支持与手机排架系统无缝对接，准确定位图书位置，便于读者快速查找图书。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-product8.png",
          name: "RFID智能盘点车",
          introduction:
            "智能盘点设备能够方便图书工作人员进行图书上架、图书盘点、统计查询等工作。移动盘点车可搭配多个手持盘点终端，满足多人同时协同盘点。盘点系统支持与手机排架系统无缝对接，准确定位图书位置，便于读者快速查找图书。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-product9.png",
          name: "RFID智能安全门禁",
          introduction:
            "安全门禁外观简洁，边框弧线优美，采用红外触发读取模式，支持多标签读取和进出人数统计，集成声光报警于一体，用于图书安全防盗检测场景。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-product10.png",
          name: "RFID智能借还柜",
          introduction:
            "智能借还柜是一种基于RFID技术的图书自助借阅延伸服务的智能终端系统，在无人值守、无人协助的情况下，可实现读者24小时自助借还图书操作。外观大气高端，操作界面易用、简单，系统运行稳定，适用于室内或室外自助借还服务场景。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-product11.png",
          name: "旗舰版RFID借还办证一体机",
          introduction:
            "自助借还一体机采用立体式设计，提供便捷化的操作模式和友好的图形界面，集借还书、检索、缴费、电子书借阅等多功能于一体，同时满足图书流通的多种业务需求，为读者提供智能化的自助服务。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-product12.png",
          name: "",
          introduction: "",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
@import "../../../assets/scss/libRFIDsolve.scss";
</style>
